import { AutoEnablePlugins, configureRuntimeApplicationForApp, getLegacyBindingContext, getRuntimeInstallerBindingContext, refreshRuntimeInstallerContributions } from "@visactor/vrender-core";

import { ScrollBarPlugin } from "./scrollbar-plugin";

function bindScrollbar(container) {
    container.isBound(ScrollBarPlugin) || (container.bind(ScrollBarPlugin).toSelf(), 
    container.bind(AutoEnablePlugins).toService(ScrollBarPlugin));
}

export function installScrollbarToApp(app) {
    configureRuntimeApplicationForApp(app), bindScrollbar(getRuntimeInstallerBindingContext()), 
    refreshRuntimeInstallerContributions();
}

export function loadScrollbar() {
    bindScrollbar(getLegacyBindingContext());
}
//# sourceMappingURL=module.js.map
